import instance from "../../services/api";

export const contragentAvrAPI = {
  async getJournal(params) {
    return await instance()
      .get("/partner/contragent_avr/journal/", { params })
      .then(res => res?.data);
  },
  async updateIncomingDocNum(contragent_avr_id, body) {
    return await instance()
      .post(`/partner/contragent_avr/incoming-doc-num/${contragent_avr_id}/`, body)
      .then(res => res?.data);
  },
  async sign(contragent_avr_id, body) {
    return await instance()
      .post(`/partner/contragent_avr/sign/${contragent_avr_id}/`, body)
      .then(res => res?.data);
  }
};
